import { forwardRef } from "react";

interface InputDateProps {
    label: string;
    name: string;
    error?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: () => void;
}

const InputDate = forwardRef<HTMLInputElement, InputDateProps>(
    ({ label, name, error, value = "", onChange, onBlur }, ref) => {
        const id = `input-${name}`;
        return (
            <div className="flex flex-col w-full items-start">
                <label htmlFor={id} className="font-medium mb-[4px]">{label}</label>
                <input
                    ref={ref}
                    id={id}
                    name={name}
                    type="date"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200"
                />
                <div className="h-[20px] mt-1">
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                </div>
            </div>
        );
    }
);

export default InputDate;
